import { useState, useEffect } from 'react'

const INITIAL_SECONDS = 653 // 10 minutes 53 seconds
const STORAGE_KEY = 'mp_countdown_start'

function getStartTime(): number {
  if (typeof window === 'undefined') return Date.now()
  const stored = sessionStorage.getItem(STORAGE_KEY)
  if (stored) {
    const parsed = parseInt(stored, 10)
    if (!isNaN(parsed)) return parsed
  }
  const now = Date.now()
  sessionStorage.setItem(STORAGE_KEY, now.toString())
  return now
}

const startTime = getStartTime()

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const elapsed = Math.floor((Date.now() - startTime) / 1000)
    return Math.max(0, INITIAL_SECONDS - elapsed)
  })

  useEffect(() => {
    if (timeLeft <= 0) return

    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000)
      const remaining = Math.max(0, INITIAL_SECONDS - elapsed)
      setTimeLeft(remaining)
      if (remaining <= 0) clearInterval(timer)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft <= 0])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  const isExpired = timeLeft <= 0

  return { minutes, seconds, timeLeft, isExpired }
}
